import { useTranslation } from 'react-i18next';
import { I18N_NAMESPACES } from '../constants/i18nConstants';
import { searchQueries } from '@as-react/common-queries';
import { useAemConfig } from '@as-react/common-components';
import { useDebouncedQuery } from './useDebouncedQuery';
import { DELAY } from '../constants/GeneralConstants';
import { SEARCH_RESULT_LIMIT } from '../constants/SearchConstants';
import { getSearchBrandAsCategories, getSearchBrands, getSearchCategories, getSearchContent, getSearchKeywords, getSearchItemGrouping, } from '../util/SearchUtil';
const getSearchResultLimit = (searchTerm) => {
    if (searchTerm) {
        switch (searchTerm.trim().length) {
            case 1:
                return SEARCH_RESULT_LIMIT.FOR_1_SEARCH_CHARACTER;
            case 2:
                return SEARCH_RESULT_LIMIT.FOR_2_SEARCH_CHARACTER;
            default:
                return SEARCH_RESULT_LIMIT.FOR_MORE_THEN_2_SEARCH_CHARACTER;
        }
    }
    else {
        return SEARCH_RESULT_LIMIT.FOR_1_SEARCH_CHARACTER;
    }
};
export const useMenuSearch = ({ searchTerm = '', suggestionsParentLink, brandsParentLink, categoriesParentLink, }) => {
    const { t } = useTranslation(I18N_NAMESPACES.navigation);
    const aemConfiguration = useAemConfig();
    const { defaultRequestParams, servicesEndpoint } = aemConfiguration;
    const elasticsearchIndex = `${aemConfiguration.activeEnvironment}_${aemConfiguration.elasticsearchIndex}`;
    const searchResultLimit = getSearchResultLimit(searchTerm);
    const { getSearchSuggestions, getSearchContentSuggestion } = searchQueries({
        servicesEndpoint,
        defaultRequestParams,
    });
    const { data: suggestions } = useDebouncedQuery(getSearchSuggestions({ query: searchTerm }, {
        enabled: Boolean(searchTerm),
        retry: false,
        select: data => ({
            keywords: getSearchKeywords(data === null || data === void 0 ? void 0 : data.keywords, suggestionsParentLink),
            brands: getSearchBrands(data === null || data === void 0 ? void 0 : data.brands, brandsParentLink),
            categories: getSearchCategories(data === null || data === void 0 ? void 0 : data.categories, categoriesParentLink),
            brandAsCategories: getSearchBrandAsCategories(data === null || data === void 0 ? void 0 : data.brandAsCategories, categoriesParentLink),
        }),
    }), DELAY.DELAY_250);
    const { data: contentSuggestion } = useDebouncedQuery(getSearchContentSuggestion({ query: searchTerm, elasticsearchIndex }, {
        enabled: Boolean(searchTerm),
        retry: false,
        select: data => ({ content: getSearchContent(data === null || data === void 0 ? void 0 : data.content) }),
    }), DELAY.DELAY_250);
    const menuSearchItemGrouping = getSearchItemGrouping(Object.assign(Object.assign({}, suggestions), contentSuggestion), searchResultLimit, t);
    return { menuSearchItemGrouping };
};
